import { LinkButton, IconPhone16 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

interface ICallButtonProps {
  phone?: string | null;
  onClick?(): void;
}

export function CallButton({ phone, onClick }: ICallButtonProps) {
  return (
    <div className={styles['buttons']}>
      <LinkButton
        id="test"
        size="L"
        theme="fill_primary"
        fullWidth
        onClick={onClick}
        beforeIcon={<IconPhone16 color="white_100" />}
        href={`tel:${phone}`}
      >
        Позвонить застройщику
      </LinkButton>
    </div>
  );
}
